// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_H76Wu","quick-view":"quick-view_RRmY9","btn":"btn_Pr5Em","icon-eye":"icon-eye"};